import { FC } from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import { useQueryClient } from 'react-query';
import { ButtonOutlinePrimary } from '@lambdacurry/component-library';
import { useRestartSubscriptionMutation, useAddReturningDiscountCodeToCartMutation } from 'lib/home/generated/queries';
import { MeQuery, OrdersQuery, RestartSubscriptionMutation } from 'lib/home/generated/types/api';
import { Grid, Card, CardContent } from 'lib/components';
import { Loading } from '../../Loading';

export const PleaseReturn: FC<{ names: { first_name: string; last_name: string } }> = ({ names }) => {
  const { mutate: restartSubscription, isLoading: isRestarting } = useRestartSubscriptionMutation();
  const { mutate: addReturningDiscountToCart, isLoading: isAdding } = useAddReturningDiscountCodeToCartMutation();
  const queryClient = useQueryClient();
  const isLoading = isRestarting || isAdding;
  const { first_name } = names;

  const bustQueryCache = (data: RestartSubscriptionMutation) => {
    queryClient.setQueryData(['Me'], (query: MeQuery) => {
      query.me.subscription.status = data.restartSubscription.status;

      return query;
    });

    queryClient.setQueryData(['Orders'], (query: OrdersQuery) => {
      query.me.subscription.status = data.restartSubscription.status;
      query.me.subscription.current_order = data.restartSubscription.current_order;
      query.me.subscription.upcoming_orders = data.restartSubscription.upcoming_orders;

      return query;
    });
  };

  const handleRestart = () =>
    restartSubscription(
      {},
      {
        onSuccess: ({ restartSubscription }) => {
          addReturningDiscountToCart(
            {},
            {
              onSuccess: ({ addReturningDiscountCodeToCart }) => {
                const updatedSubscription = {
                  ...restartSubscription,
                  current_order: {
                    ...restartSubscription.current_order,
                    medusa_cart: { ...restartSubscription.current_order.medusa_cart, ...addReturningDiscountCodeToCart }
                  }
                };

                bustQueryCache({ restartSubscription: updatedSubscription });
              }
            }
          );
        }
      }
    );

  return isLoading ? (
    <Loading />
  ) : (
    <Card>
      <Grid>
        <div className="col-span-12 md:col-span-6">
          <StaticImage
            className="block mt-8 md:mt-0 max-w-[160px] sm:max-w-[240px] md:max-w-none mx-auto transition-all"
            src="../../../images/please-return.png"
            alt="A delicious dish of pork, hard-boiled eggs, and veggies."
          />
        </div>

        <CardContent className="col-span-12 md:col-span-6 md:self-center">
          <h3>{first_name}, Come Back and Save More!</h3>
          <p>Rejoin today and save 35% on your first box.</p>

          <ButtonOutlinePrimary className="mt-2 w-full md:w-56" onClick={handleRestart}>
            Claim Your Box
          </ButtonOutlinePrimary>
        </CardContent>
      </Grid>
    </Card>
  );
};
